export const dateConstants = {
  DATE: "YYYY MMM DD",
  TIME: "hh:mm A",
  FULLDATETIME: "DD/MM/YY - HH:mm",
};
